import styled from 'styled-components'

export const MAIN_COLOR = '_006BFF'
export const SECONDARY_COLOR = 'focusBorderColor'

export const Container = styled.div`
  display: flex;
  width: fit-content;
`

export const StarsContainer = styled.button<{
  disabled: boolean
}>`
  position: relative;
  width: fit-content;
  height: fit-content;
  padding: 0;
  border: 0;
  background-color: transparent;

  ${({ disabled }) => disabled && 'pointer-events: none;'}

  margin-left: 8px;

  &:first-child {
    margin-left: 0;
  }
`
